import selectpicker from 'bootstrap-select'

(require('smartwizard/dist/js/jquery.smartWizard.js'))(window, window.jQuery)

// Preserve the globals exposed by the full Workplace plugin pack for the
// registration form and its selectpicker refresh lifecycle.
window.spicker = window.selectpicker = selectpicker
window.refreshSelectPicker = function(selector) { jQuery(selector).selectpicker() }
window.destroySelectPicker = function(selector) { jQuery(selector).selectpicker('destroy') }
window.initSelectPicker = function(selector) { jQuery(selector).selectpicker('refresh') }
import selectpicker from 'bootstrap-select'

(require('smartwizard/dist/js/jquery.smartWizard.js'))(window, window.jQuery)

// Preserve the globals exposed by the full Workplace plugin pack for the
// registration form and its selectpicker refresh lifecycle.
window.spicker = window.selectpicker = selectpicker
window.refreshSelectPicker = function(selector) { jQuery(selector).selectpicker() }
window.destroySelectPicker = function(selector) { jQuery(selector).selectpicker('destroy') }
window.initSelectPicker = function(selector) { jQuery(selector).selectpicker('refresh') }
